import { render, staticRenderFns } from "./Dispatching.vue?vue&type=template&id=68cc8cde&scoped=true&"
import script from "./Dispatching.vue?vue&type=script&lang=js&"
export * from "./Dispatching.vue?vue&type=script&lang=js&"
import style0 from "./Dispatching.vue?vue&type=style&index=0&id=68cc8cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc8cde",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cc8cde')) {
      api.createRecord('68cc8cde', component.options)
    } else {
      api.reload('68cc8cde', component.options)
    }
    module.hot.accept("./Dispatching.vue?vue&type=template&id=68cc8cde&scoped=true&", function () {
      api.rerender('68cc8cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dispatching.vue"
export default component.exports